/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class DesktopService {
    public isDesktop(): boolean {
        return window.innerWidth > 1098;
    }
}
